<div class="news-grid">
  <h2 class="news-grid__title" *ngIf="category">{{category}}</h2>
  <div class="news-grid__container" [style.--columns]="columns">
    <article class="news-grid__item" *ngFor="let article of articles">
      <a [routerLink]="['/noticias', article.slug]" class="news-grid__link">
        <div class="news-grid__image">
          <img *ngIf="getImageSrc(article)" [src]="getImageSrc(article)" [alt]="article.title">
        </div>
        <div class="news-grid__content">
          <span class="news-grid__category">{{ article.subcategory || article.category }}</span>
          <h3 class="news-grid__article-title">{{article.title}}</h3>
          <p class="news-grid__article-excerpt" *ngIf="article.excerpt">
            {{article.excerpt | slice:0:80}}...
          </p>
          <div class="news-grid__metadata">
            <span class="news-grid__date">{{article.publishDate | date:'dd/MM/yyyy'}}</span>
            <span class="news-grid__author" *ngIf="article.author">Por {{article.author}}</span>
          </div>
        </div>
      </a>
    </article>
  </div>
</div>
